import {api} from "../http/apiClient"

const ApiShare = () => {
  const sharePlanning = (planningId) => {
    return api.post(`/plans/${planningId}/share/`)
  }
  const sharePlanningPostCredit = (planningId) => {
    return api.post(`/post-credit/${planningId}/share/`)
  }
  const acceptSharedPlanning = (uuid, cnpj) => {
    return api.get(`/plans/shared/${uuid}/accept/${cnpj ? `?cnpj=${cnpj}` : ''}`)
  }
  const acceptSharedPlanningPostCredit = (uuid, cnpj) => {
    return api.get(`/post-credit/shared/${uuid}/accept/${cnpj ? `?cnpj=${cnpj}` : ''}`)
  }
  const notifications = () => {
    return api.get(`/notifications/`)
  }
  const changeStatus = (uuid, data) => {
    return api.patch(`/plans/invite/${uuid}/update/`, data)
  }
  const changeStatusPostCredit = (uuid, data) => {
    return api.patch(`/post-credit/invite/${uuid}/update/`, data)
  }
  const notificationsMakeRead = (uuid) => {
    return api.patch(`/notifications/${uuid}/mark-read/`)
  }

  return {
    sharePlanning,
    sharePlanningPostCredit,
    acceptSharedPlanning,
    acceptSharedPlanningPostCredit,
    notifications,
    changeStatus,
    changeStatusPostCredit,
    notificationsMakeRead,
  }
}

export default ApiShare
